/**
 * Der Ausgang zur oeffentlichen Startseite fuer angemeldete Mitglieder.
 *
 * Die Startseite leitet Angemeldete nach /intern um (PublicOnlyRoute) - sie
 * ist die Seite fuer Gaeste und Interessenten. Wer sie sich trotzdem ansehen
 * will, kommt ueber den Menueeintrag "Oeffentliche Seite" hin: Der setzt hier
 * ein Sitzungs-Kennzeichen, und das Gate leitet dann nicht um.
 *
 * Warum sessionStorage und nicht der Navigations-State von React Router:
 * Ein State ueberlebt zwar einen Reload, aber NICHT den Klickpfad. Startseite
 * -> Galerie -> Logo -> und schon ist er weg, der naechste Aufruf von / wirft
 * zurueck nach innen. Die oeffentliche Seite waere ein Ort, den man betreten,
 * aber nicht durchlaufen kann. Pro Tab ist genau richtig: Der naechste Start
 * der App fuehrt wieder in den Mitgliederbereich.
 *
 * Gleiches Muster wie der Reload-Riegel in components/RouteError.js. Jeder
 * Zugriff in try/catch: Im privaten Fenster oder bei gesperrtem Speicher
 * wirft sessionStorage, und daran darf keine Navigation scheitern.
 */
const KEY = 'mt_public';

export function allowPublicHome() {
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch {
    // Ohne Speicher leitet das Gate weiter um - unschoen, aber harmlos.
  }
}

export function isPublicHomeAllowed() {
  try {
    return window.sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function clearPublicHome() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // nichts zu tun
  }
}
